import React from 'react';

import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

import NumberInput from '@common/components/NumberInput/NumberInput';

const SizeStyle = ({
  min = 0,
  max = 100,
  propKey = 'size',
  label = 'column_width',
  disableHelperText = false,
  blockOutboundValues,
}) => {
  const {
    actions: { setProp },
    propValue,
  } = useNode(({ data }) => {
    return {
      propValue: data?.props[propKey],
    };
  });
  const { t } = useTranslation();

  const onChange = (e) => {
    const newValue = e.target.value;
    if (blockOutboundValues) {
      if (newValue > propValue ? newValue <= max : propValue >= min + 1) {
        setProp((props) => {
          props[e.target.name] = newValue;
        }, 500);
      }
    } else {
      setProp((props) => {
        props[e.target.name] = newValue;
      }, 500);
    }
  };

  return (
    <NumberInput
      min={min}
      max={max}
      label={t(label)}
      value={propValue}
      name={propKey}
      onChange={onChange}
      disableHelperText={disableHelperText}
    />
  );
};

export default SizeStyle;
